/* unplugin-vue-components disabled */import { render } from "./pdfchange.vue.vue?vue&type=template&id=33522a6c&scoped=true"
import script from "./pdfchange.vue.vue?vue&type=script&lang=js"
export * from "./pdfchange.vue.vue?vue&type=script&lang=js"

import "./pdfchange.vue.vue?vue&type=style&index=0&id=33522a6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33522a6c"]])

export default __exports__